import React, { Component } from "react";
import "../../Controls/ListingPage.css";
import Input from "../../Controls/Input";

import WhatsAppIntegration from "./WhatsAppIntegration";
import PaymentGatewayIntegration from "./PaymentGatewayIntegration";
import LogisticIntegration from "./LogisticIntegration";
import LoyaltyIntegration from "./LoyaltyIntegration";
import WarehouseIntegration from "./WarehouseIntegration";
import AdsrIntegration from "./AdsrIntegration";

class Integration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedIntegrationType: ""
    };
  }

  // ✅ Safe access using hasOwnProperty
  getRegistrationId = () => {
    if (
      this.props &&
      this.props.hasOwnProperty("registration") &&
      this.props.registration &&
      this.props.registration.hasOwnProperty("registration") &&
      this.props.registration.registration &&
      this.props.registration.registration.hasOwnProperty("key")
    ) {
      return this.props.registration.registration.key;
    }
    return "";
  };

  // ✅ No hooks, normal method
  getIntegrationComponents = () => {
    const registrationId = this.getRegistrationId();

    return {
      whatsapp: (
        <WhatsAppIntegration    {...this.props} registrationId={registrationId} />
      ),
      paymentGateway: (
        <PaymentGatewayIntegration    {...this.props}  registrationId={registrationId} />
      ),
      logistic: (
        <LogisticIntegration    {...this.props}  registrationId={registrationId} />
      ),
      // loyalty: (
      //   <LoyaltyIntegration    {...this.props}  registrationId={registrationId} />
      // ),
      // warehouse: (
      //   <WarehouseIntegration    {...this.props}  registrationId={registrationId} />
      // ),
      // adsrIntegration: (
      //   <AdsrIntegration    {...this.props}  registrationId={registrationId} />
      // )
    };
  };

  renderSelectedIntegrations = () => {
    const integrationComponents = this.getIntegrationComponents();

    if (this.state.selectedIntegrationType === "") {
      return (
        <div className="space-y-10 grid gap-7">
          {integrationComponents.whatsapp}
          {integrationComponents.paymentGateway}
          {integrationComponents.logistic}
          {/* {integrationComponents.loyalty}
          {integrationComponents.warehouse}
          {integrationComponents.adsrIntegration} */}
        </div>
      );
    }

    return (
      integrationComponents[this.state.selectedIntegrationType] || null
    );
  };

  render() {
    return (
      <div className="header-margin">
        <div style={{ padding: "10px" }}>
          <div className="listing-page-header">
            <div className="left left-40">
              <div className="listing-page-header-title">
                Integration
              </div>
            </div>
          </div>

          <div
            className="listing-page-content"
            style={{
              padding:"10px",
              height: window.innerHeight - 100 + "px",
              overflowY: "auto",
              backgroundColor: "white",
              borderBottomLeftRadius: "12px",
              borderBottomRightRadius: "12px"
            }}
          >
            <div style={{
    width: window.innerWidth >= 1024 ? "400px" : "100%"
  }}>
            <Input
              type="select"
              label="Filter by Category"
              value={this.state.selectedIntegrationType}
              onChange={(v) =>
                this.setState({ selectedIntegrationType: v })
              }
            >
              <option value="">All Integrations</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="paymentGateway">
                Payment Gateway
              </option>
              <option value="logistic">Logistic</option>
              {/* <option value="loyalty">Loyalty</option>
              <option value="warehouse">Warehouse</option>
              <option value="adsrIntegration">
                ADSR / Pathfinder
              </option> */}
            </Input>
            </div>

            <div>
              {this.renderSelectedIntegrations()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Integration;